// extracted by mini-css-extract-plugin
module.exports = {"colombia-container":"styles-m__colombia-container__3cyQC"};